export const styles = {
    autoCompleteStyles: {
        width: '100%',
        '& .MuiFormControl-root': {
            width: '100%',
        },
    },
    smartContractAutocompleteChainFieldHeight: {
        maxHeight: '132px',
    },
};
